// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Pdf: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
<g>
	<path d="M4.33,8.5H0.17v29.17c0,2.29,1.88,4.17,4.17,4.17H33.5v-4.17H4.33V8.5z"/>
	<rect x="14.75" y="13.71" width="2.08" height="2.08"/>
	<rect x="25.17" y="13.71" width="2.08" height="6.25"/>
	<path d="M37.67,0.17h-25c-2.29,0-4.17,1.88-4.17,4.17v25c0,2.29,1.88,4.17,4.17,4.17h25c2.29,0,4.17-1.88,4.17-4.17v-25
		C41.83,2.04,39.96,0.17,37.67,0.17z M19.96,15.79c0,1.73-1.4,3.12-3.12,3.12h-2.08v4.17h-3.12v-12.5h5.21
		c1.73,0,3.12,1.4,3.12,3.12V15.79z M30.37,19.96c0,1.73-1.4,3.12-3.12,3.12h-5.21v-12.5h5.21c1.73,0,3.12,1.4,3.12,3.12V19.96z
		 M38.71,13.71h-3.12v2.08h3.12v3.12h-3.12v4.17h-3.12v-12.5h6.25V13.71z"/>
</g>
</svg>;
};

export default React.memo(Pdf);
